module.exports = __webpack_public_path__ + "Java8.53433bdfdce4aa51583e.png";


//////////////////
// WEBPACK FOOTER
// E:/Java/ResumeAngular/resume/src/assets/images/Java8.png
// module id = ../../../../../src/assets/images/Java8.png
// module chunks = main